import React from 'react';
import './teamSection.scss';
import TeamCardItem from "./components/TeamCardItem";

interface TeamSectionProps {
	isAboutUs: boolean;
}

const TeamSection = (props: TeamSectionProps) => {
	return (
		<div className={`teamSection ${props.isAboutUs ? 'aboutUs' : ''}`}>
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="teamSection__title">
				<h2>Team</h2>
				<span>The great minds behind our work</span>
			</div>
			<div className="teamSection__content">
				<TeamCardItem
					imgId={'leo-avatar'}
					name={'Leo'}
					post={'CEO'}
					description={'In Web-3 since 2020. A serial entrepreneur with extensive experience in building Web-2 businesses in the CPA field. After selling the Web-2 business, a decision was made to develop the Web-3 market, which is being successfully pursued to this day.'}
				/>
				<TeamCardItem
					imgId={'william-avatar'}
					name={'William'}
					post={'CTO & Co-Founder'}
					description={'Professionally engaged in the development of Web-3 products since 2019. At NFD, he is responsible for solving technical tasks of any complexity. His duties include architectural design, product development, as well as close collaboration with the team to address key processes in product development.'}
				/>
				<TeamCardItem
					imgId={'vadim-avatar'}
					name={'Vadim'}
					post={'CCO & Co-Founder'}
					description={'In Web-3 since 2020. At NFD, he is responsible for planning, strategy, documentation development, as well as overseeing all content released under the NFD banner across all platforms and much more. He has extensive experience in various sectors and niches of the Web-3 market.'}
				/>
				<TeamCardItem
					imgId={'vitaliy-avatar'}
					name={'Vitalik Hedo'}
					post={'Deputy CTO & Co-Founder'}
					description={'Vitalik manages the entire development team and oversees the development processes. He also participates in product planning and discussions, their technical icons, task setting, sprint planning with the team, and much more.'}
				/>
				<TeamCardItem
					imgId={'pavel-avatar'}
					name={'Pavel'}
					post={'Head of Product'}
					description={'At NFD, he is responsible for developing the logical structure of product operations, testing new features, and supporting NFD product users. In Web-2, he has over 10 years of experience as a system administrator.'}
				/>
				<TeamCardItem
					imgId={'stanislav-avatar'}
					name={'Stanislav'}
					post={'Senior Fullstack Developer (Web3)'}
					description={'Holds the position of Senior Web-3 Developer. He participates in solving highly complex tasks across many products. Thanks to his extensive experience in various Open Source Web-3 projects, he excels at developing the on-chain logic for NFD products.'}
				/>
			</div>
			<div className={`teamSection__background ${props.isAboutUs ? 'aboutUs' : ''}`}></div>
		</div>
	);
};

export default TeamSection;